"use client";

import { FC, useEffect, useRef } from "react";
import { useWindowSize } from "react-use";

import { Container as SharedContainer, ContainerProps as SharedContainerProps } from "@Shared/ui";

const CSS_VAR_HEADER_HEIGHT = "--header-height";

export type ContainerProps = SharedContainerProps;

export const Container: FC<ContainerProps> = props => {
    const refComponent = useRef<HTMLDivElement>(null);

    const { width } = useWindowSize();

    useEffect(() => {
        if (!refComponent.current) {
            return;
        }

        document.documentElement.style.setProperty(CSS_VAR_HEADER_HEIGHT, `${refComponent.current.offsetHeight}px`);

        return () => {
            document.documentElement.style.removeProperty(CSS_VAR_HEADER_HEIGHT);
        };
    }, [width]);

    return <SharedContainer ref={refComponent} {...props} />;
};
